// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/apps/api_limits/app_group_rate_limit_datatable/(/:app_group_id)" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsApiLimitsAppGroupRateLimitDatatableAppGroupId } from "./constants";
import type {
  AppsApiLimitsAppGroupRateLimitDatatableAppGroupIdParams,
  AppsApiLimitsAppGroupRateLimitDatatableAppGroupIdResult,
} from "./types";

export const getDataTableAppsApiLimitsAppGroupRateLimitDatatableAppGroupId = reactQueryTableFetcherAdapter(
  appsApiLimitsAppGroupRateLimitDatatableAppGroupId,
  (
    signal: AbortSignal,
    {
      appGroupId,
      query = {},
      groupby,
      limit = 20,
      start = 0,
      sortdir,
      sortby,
    }: AppsApiLimitsAppGroupRateLimitDatatableAppGroupIdParams
  ): Promise<AppsApiLimitsAppGroupRateLimitDatatableAppGroupIdResult> => {
    return fetch(
      `/apps/api_limits/app_group_rate_limit_datatable/${appGroupId ? `/${appGroupId}` : ""}`,
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        query: serializeQueryObjects(query),
      },
      { signal }
    );
  }
);
